import { Grid, Typography, Box, List, ListItem, Button, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import aboutUsSectionStyles from "./aboutUsSection.styles";
import aboutUsRightImg from "../../../assets/images/aboutUsRightImg.webp";
import { ROUTE_PATH } from "../../../constants/route";
import { WANDEROBE_CONTENT } from "../../../constants/lang";


const AboutUsSection = ({ isPublic, setIsFaqVisible, isCustomerSupport}) => {
    const styles = aboutUsSectionStyles;
    const naviagte = useNavigate();
    const { goback, titlemain } = WANDEROBE_CONTENT;
    return (
        <Box
            sx={{
                ...styles.containerWrapper,
                pt: isCustomerSupport ? ( isPublic ? "10px" : "30px") : { xs: "20px", sm: "30px", md: "40px", lg: "70px" },
                pb: isCustomerSupport ? "10px" : { xs: "33.06px", sm: "30px", md: "40px", lg: "70px" }
            }} 
                id="wanderobeSection"
        >
            {isCustomerSupport && <Box sx={styles.titleBox}>
                <IconButton sx={styles.backButton} aria-label={goback} onClick={() => setIsFaqVisible(false)}>
                    <ArrowBackIcon />
                </IconButton>
                <Typography sx={styles.titleMain}>{titlemain}</Typography>
            </Box>}
            <Grid container sx={styles.container}>
                <Grid item xs={12} sm={7.6}>
                    <Typography variant="h4" sx={styles.title}>About Us</Typography>
                    <Box sx={styles.titleLine} />
                    <Typography variant="body1" sx={styles.subtitle}>
                        Empowering Designers. Inspiring Travelers.
                    </Typography>
                    <Typography variant="body1" sx={{ ...styles.description, mt: { xs: "18px", sm: "31px" } }}>
                        Wanderobe is a one-of-a-kind platform connecting independent and emerging fashion designers with travelers seeking curated wardrobe experiences in destination cities. We bridge the gap between your designs and discerning customers, providing:
                    </Typography>
                    <List sx={styles.list}>
                        <ListItem sx={styles.listItem} >
                            <Typography variant="body1" sx={styles.descriptionTitle}>
                                Seamless Logistics:
                            </Typography>
                            <Typography variant="body1" sx={styles.listDescription}>
                                We manage order processing, delivery, and returns so you can focus on your craft.
                            </Typography>
                        </ListItem>
                        <ListItem sx={styles.listItem}>
                            <Typography variant="body1" sx={styles.descriptionTitle}>
                                Increased Exposure:
                            </Typography>
                            <Typography variant="body1" sx={styles.listDescription}>
                                Showcase your unique designs to a global audience of travelers.
                            </Typography>
                        </ListItem>
                        <ListItem sx={styles.listItem}>
                            <Typography variant="body1" sx={styles.descriptionTitle}>
                                Sales Support:
                            </Typography>
                            <Typography variant="body1" sx={styles.listDescription}>
                                Access a streamlined system for showcasing and selling your creations.
                            </Typography>
                        </ListItem>
                    </List>
                    <Typography variant="body1" sx={{ ...styles.description, mt: { xs: "18px", sm: "28px" } }}>
                        As a seller, you'll gain access to a customer base of travelers eager to discover unique, high-quality fashion while Wanderobe ensures a premium customer experience.
                    </Typography>
                    { isPublic && <Box sx={styles.buttonWrapper}>
                        <Button variant="contained" sx={styles.button} onClick={() => naviagte(ROUTE_PATH.SIGNUP)}>
                            Join Wanderobe Today
                        </Button>
                    </Box>}
                </Grid>
                <Grid item xs={12} sm={4.4} sx={{ textAlign: "right", display: { xs: "none", sm: "block" } }}>
                    <Box component="img" src={aboutUsRightImg} alt="About Us" sx={styles.img} />
                </Grid>
            </Grid>
        </Box>
    )
}

export default AboutUsSection;